<template>
  <section class="list">
    <div class="row">
      <article class="card type-card" @click="select('COOPERATIVE')">
        <div class="type-icon-wrapper cooperative-bg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            class="type-icon"
            fill="none"
          >
            <!-- Invernadero simplificado -->
            <rect
              x="6"
              y="30"
              width="52"
              height="26"
              rx="2"
              fill="#e8f5e9"
              stroke="#107631"
              stroke-width="2.5"
            />
            <path
              d="M6 30 Q32 6 58 30"
              stroke="#107631"
              stroke-width="2.5"
              fill="#c8e6c9"
            />
            <!-- ventanas -->
            <rect
              x="14"
              y="38"
              width="10"
              height="10"
              rx="1"
              fill="#107631"
              opacity="0.3"
            />
            <rect
              x="27"
              y="38"
              width="10"
              height="10"
              rx="1"
              fill="#107631"
              opacity="0.3"
            />
            <rect
              x="40"
              y="38"
              width="10"
              height="10"
              rx="1"
              fill="#107631"
              opacity="0.3"
            />
            <!-- puerta -->
            <rect
              x="27"
              y="46"
              width="10"
              height="10"
              rx="1"
              fill="#107631"
              opacity="0.5"
            />
          </svg>
        </div>
        <h3>Experimental</h3>
      </article>

      <article class="card type-card" @click="select('COMMERCIAL')">
        <div class="type-icon-wrapper commercial-bg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            class="type-icon"
            fill="none"
          >
            <!-- Personas / socios -->
            <circle
              cx="22"
              cy="20"
              r="9"
              fill="#fff3e0"
              stroke="#e65100"
              stroke-width="2.5"
            />
            <circle
              cx="42"
              cy="20"
              r="9"
              fill="#fff3e0"
              stroke="#e65100"
              stroke-width="2.5"
            />
            <path
              d="M4 52 C4 38 14 32 22 32 C27 32 31 34 32 36 C33 34 37 32 42 32 C50 32 60 38 60 52"
              stroke="#e65100"
              stroke-width="2.5"
              fill="#fff3e0"
            />
            <!-- vínculo -->
            <path
              d="M27 36 Q32 40 37 36"
              stroke="#e65100"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <h3>Socios</h3>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "SelectFarmType",

  methods: {
    select(type) {
      this.$root.$emit("farm-type", type);
    },
  },
};
</script>

<style scoped>
.type-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 16px;
}

.type-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.type-card:active {
  transform: translateY(-2px);
}

.type-icon-wrapper {
  width: 100%;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px 8px 0 0;
}

.cooperative-bg {
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
}

.commercial-bg {
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
}

.type-icon {
  width: 90px;
  height: 90px;
}

h3 {
  margin-top: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  text-align: center;
}
</style>
